GatorSurvey.app.directive("gsPriorityQuestion", ['surveyResponseService', GsPriorityQuestion]);
function GsPriorityQuestion(surveyResponseService) {
    return {
        restrict: 'AE',
        scope: {
            gsModel: "=ngModel",
            mode: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/Questions/Templates/PriorityQuestionLive.html',
        controller: ['$scope', function ($scope) {
          
            $scope.getAllowedIds = function(list) {
                var r = $.map(list, function(item) {
                    return item.id;
                });
                return r;
            };
            
            $scope.updateList = function(index) {
                $scope.gsModel.priorityList.splice(index, 1);
                surveyResponseService.updateResponseQuestion($scope.gsModel, $scope.gsModel.priorityList);
            };

            $scope.moveItemDownList = function(element) {
                var index = $scope.gsModel.priorityList.indexOf(element);
                if(index === -1){
                    return false;
                }
                if($scope.gsModel.priorityList[index+1]){
                    $scope.gsModel.priorityList.splice(index, 2, $scope.gsModel.priorityList[index+1], $scope.gsModel.priorityList[index]);
                }else{
                    return 0;
                }
            };

            $scope.moveItemUpList = function (element) {
                var index = $scope.gsModel.priorityList.indexOf(element);
                if (index === -1) {
                    return false;
                }
                if ($scope.gsModel.priorityList[index - 1]) {
                    $scope.gsModel.priorityList.splice(index - 1, 2, $scope.gsModel.priorityList[index], $scope.gsModel.priorityList[index - 1]);
                } else {
                    return 0;
                }
            };
            
                surveyResponseService.AddNewQuestion($scope.gsModel,
                    function(response) {
                        for (var i = 0; i < $scope.gsModel.priorityList.length; i++) {
                            for (var p = 0; p < response.priorityAnswers.length; p++) {
                                if (response.priorityAnswers[p].id === $scope.gsModel.priorityList[i].id) {
                                    $scope.gsModel.priorityList[i].orderNo = response.priorityAnswers[p].priority;
                                }
                            }
                        }
                        var temp = [];
                        for (var ci = 0; ci < $scope.gsModel.priorityList.length; ci++) {
                            for (var c = 0; c < $scope.gsModel.priorityList.length; c++) {
                                if ($scope.gsModel.priorityList[c].orderNo === (ci + 1)) {
                                    temp.push($scope.gsModel.priorityList[c]);
                                }
                            }
                        }
                        $scope.gsModel.priorityList = temp;

                    });
            
        }]
    };

}